import { Shape } from "./Style";
import { style } from "./StyleType";

interface TmpShapeCustomProps {
    children: React.ReactNode;
}

export default function TmpShapeCustom(props: TmpShapeCustomProps) {

    // Passing style props to styled component
    Shape.defaultProps = style;

    return (
        <Shape>
            {props.children}
        </Shape>
    );

}